export default __webpack_public_path__ + "static/carDesktop-6d7b5a29428ae398e177f69be8f63ef0.webp";